<div id="firebaseui-auth-container" class="auth-container">
</div>
